"use client";

import React from "react";

const BenefitsOfNightGuards: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        The Benefits of Our Custom Night Guards
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Investing in a custom night guard from Smile4Me offers numerous benefits for your oral health and overall well-being. By wearing a custom night guard, you can expect:
      </p>
      <ul className="list-disc list-inside space-y-2 text-gray-700 text-base sm:text-lg">
        <li>Reduced muscle strain around the jaw joint (TMJ)</li>
        <li>Protection against tooth enamel damage and wear</li>
        <li>Prevention of tooth sensitivity and discomfort</li>
        <li>Improved sleep quality by minimizing disruptive noises associated with teeth grinding</li>
        <li>Potential reduction in symptoms related to TMJ disorders, such as headaches and facial pain</li>
        <li>Preservation of your natural tooth structure, reducing the need for extensive restorative dentistry in the future</li>
      </ul>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Wearing a custom night guard not only safeguards your teeth but also promotes better overall oral health. By addressing bruxism early on, you can prevent more severe issues from developing and maintain a healthy, beautiful smile.
      </p>
    </div>
  );
};

export default BenefitsOfNightGuards;